import styled from 'styled-components';
import { colors } from '@oxygen/theme';
import { CloseLine } from '@oxygen/assets';

export const CloseIcon = styled(CloseLine)`
  color: ${colors.night2};
  cursor: pointer;
  position: absolute;
  height: 2rem;
  right: 4rem;
  top: 4rem;
  width: 2rem;
`;

export const Container = styled.div`
  background-color: ${colors.night3};
  color: ${colors.white};
  display: flex;
  font-size: 1.5rem;
  align-items: center;
  padding: 1.6rem;
`;

export const Explain = styled.span`
  background-color: ${colors.white};
  border-radius: 50%;
  color: ${colors.coral2};
  display: inline-block;
  font-size: 1.4rem;
  font-weight: 700;
  height: 2.4rem;
  line-height: 2.4rem;
  margin-left: 8px;
  text-align: center;
  width: 2.4rem;
`;

export const ExplanationBackground = styled.div`
  background-color: ${colors.storm1};
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
`;

export const ExplanationWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 4px;
  padding: 4rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  opacity: 1;
`;
